export default "__VITE_ASSET__DViv0ktZ__"